import React from 'react';

import Button, { ButtonProps } from '../../library/button/button';

import { useScheduleAppointment } from '../../shared/hooks/hooks';

import { trackAction } from '../../shared/utils/analytics/analytics';

function ScheduleAppointmentButton(props: ButtonProps) {
  const {
    children = 'make an appointment',
    isSecondary = true,
    ...restProps
  } = props;

  const { handleScheduleAppointment } = useScheduleAppointment();

  return (
    <Button
      {...restProps}
      isSecondary={isSecondary}
      onClick={() => {
        if (window.location.pathname.includes('/wheel-torque')) {
          trackAction('torque_schedule_appointment');
        }

        handleScheduleAppointment();
      }}
    >
      {children}
    </Button>
  );
}

export default ScheduleAppointmentButton;
